export const SET_SURVEYS = 'setSurveys';
export const CLEAR_SURVEYS = 'clearSurveys';
export const CLEAR_SURVEY = 'clearSurvey';
export const SET_INTEGRATIONS = 'setIntegrations';
export const CLEAR_INTEGRATIONS = 'clearIntegrations';
export const SET_INTEGRATION = 'setIntegration';
export const SET_QUERY_PARAMS = 'setQueryParams';
export const CLEAR_QUERY_PARAMS = 'clearQueryParams';
export const CLEAR_DELETED_ITEMS = 'clearDeletedItems';
export const SET_SURVEY = 'setSurvey';
export const SET_TEAMS_PERMISSION = 'setTeamsPermission';
export const CLEAR_TEAMS_PERMISSION = 'clearTeamsPermission';
export const SET_CATEGORIES = 'setCategories';
export const CLEAR_CATEGORIES = 'clearCategories';
export const SET_USER_TEAMS = 'setUserTeams';
export const CLEAR_USER_TEAMS = 'clearUserTeams';
export const CLEAR_SURVEY_ITEM_CHILDREN = 'clearSurveyItemChildren';
export const UPDATE_SURVEY_ITEM = 'updateSurveyItem';
export const ADD_SURVEY_ITEM = 'addSurveyItem';
export const SET_SELECTED_SURVEY_ITEM_INDEX = 'setSelectedSurveyItemIndex';
export const CLEAR_SELECTED_SURVEY_ITEM_INDEX = 'clearSelectedSurveyItemIndex';
export const ADD_DELETED_ITEMS = 'addDeletedItems';
export const REMOVE_SURVEY_ITEM = 'removeSurveyItem';
export const SET_NAME = 'setName';
export const REMOVE_CATEGORIE_ITEM = 'removeCategorieItem';
export const SET_STATUS = 'setStatus';
export const SET_SURVEY_ITEM_QUESTION = 'setSurveyItemQuestion';
export const SET_SURVEY_ITEM_COMMENTS_ENABLED = 'setSurveyItemCommentsEnabled';
export const SET_SURVEY_ITEM_DETRACTOR_COMMENT = 'setSurveyItemDetractorComment';
export const SET_SURVEY_ITEM_NEUTRAL_COMMENT = 'setSurveyItemNeutralComment';
export const SET_SURVEY_ITEM_PROMOTER_COMMENT = 'setSurveyItemPromoterComment';
export const SET_SURVEY_ITEM_BUTTON_DESIGN = 'setSurveyItemButtonDesign';
export const SET_SURVEY_ITEM_INVERTED_SCALE = 'setSurveyItemInvertedScale';
export const SET_SURVEY_ITEM_OBLIGATORY = 'setSurveyItemObligatory';
export const SET_SURVEY_ITEM_OBLIGATORY_DETRACTOR = 'setSurveyItemObligatoryDetractor';
export const SET_SURVEY_ITEM_OBLIGATORY_NEUTER = 'setSurveyItemObligatoryNeuter';
export const SET_SURVEY_ITEM_OBLIGATORY_PROMOTOR = 'setSurveyItemObligatoryPromotor';
export const SET_SURVEY_ITEM_COLOR_PATTERN = 'setSurveyItemColorPattern';
export const SET_SURVEY_ITEM_CUSTOM_COLOR = 'setSurveyItemCustomColor';
export const SET_SURVEY_ITEM_COMMENT_QUESTION = 'setSurveyItemCommentQuestion';
export const SET_SURVEY_ITEM_SCALE_TYPE = 'setSurveyItemScaleType';
export const SET_SURVEY_ITEM_MIN_SCALE = 'setSurveyItemMinScale';
export const SET_SURVEY_ITEM_MAX_SCALE = 'setSurveyItemMaxScale';
export const SET_SURVEY_ITEM_BUTTON_SUBTITLE_MIN = 'setSurveyItemButtonSubtitleMin';
export const SET_SURVEY_ITEM_BUTTON_SUBTITLE_MAX = 'setSurveyItemButtonSubtitleMax';
export const SET_SURVEY_ITEM_URL = 'setSurveyItemUrl';
export const SET_SURVEY_ITEM_EXTENSION = 'setSurveyItemExtension';
export const SET_SURVEY_ITEM_ALIGN = 'setSurveyItemAlign';
export const ADD_SURVEY_ITEM_OPTION = 'addSurveyItemOption';
export const REMOVE_SURVEY_ITEM_OPTION = 'removeSurveyItemOption';
export const SET_SURVEY_ITEM_HORIZONTAL_ALIGN = 'setSurveyItemHorizontalAlign';
export const SET_SURVEY_ITEM_MULTIPLE_ANSWERS = 'setSurveyItemMultipleAnswers';
export const SET_SURVEY_ITEM_OPTION_OTHER = 'setSurveyItemOptionOther';
export const SET_SURVEY_ITEM_RANDOMIZE = 'setSurveyItemRandomize';
export const SET_SURVEY_ITEM_COMPOSITE_QUESTION = 'setSurveyItemCompositeQuestion';
export const SET_SURVEY_ITEM_OPTION_LANGUAGE = 'setSurveyItemOptionLanguage';
export const SET_SURVEY_ITEM_COMPOSITE_CATEGORY_LANGUAGE = 'setSurveyItemCompositeCategoryLanguage';
export const SET_SURVEY_ITEM_COMPOSITE_SUB_CATEGORY_LANGUAGE = 'setSurveyItemCompositeSubCategoryLanguage';
export const SET_PRIMARY_COLOR = 'setPrimaryColor';
export const SET_SECONDARY_COLOR = 'setSecondaryColor';
export const SET_DEFAULT_LANGUAGE = 'setDefaultLanguage';
export const SET_MULTI_LANGUAGE = 'setMultiLanguage';
export const CLEAR_SURVEY_ITEMS = 'clearSurveyItems';
export const TOGGLE_JUMP_LOGIC = 'toggleJumpLogic';
export const TOGGLE_ITEM_JUMP_LOGIC = 'toggleItemJumpLogic';
export const RESET_ITEM_JUMP_LOGIC = 'resetItemJumpLogic';
export const SET_JUMP_LOGIC_ACTION = 'setJumpLogicAction';
export const SET_JUMP_LOGIC_VALUE = 'setJumpLogicValue';
export const SET_JUMP_LOGIC_OTHER_OPTION_ACTION = 'setJumpLogicOtherOptionAction';
export const SET_JUMP_LOGIC_OTHER_OPTION_VALUE = 'setJumpLogicOtherOptionValue';
export const SET_COOLDOWN_DISTRIBUTION = 'setCooldownDistribution';
export const SET_COOLDOWN_RESPONSES = 'setCooldownResponses';
export const SET_SURVEY_ITEM_COMPOSITE_ENABLE_DETRACTOR = 'setSurveyItemCompositeEnableDetractor';
export const SET_SURVEY_ITEM_COMPOSITE_ENABLE_DETRACTOR_CHILDREN = 'setSurveyItemCompositeEnableDetractorChildren';
export const SET_SURVEY_ITEM_COMPOSITE_ENABLE_NEUTRAL = 'setSurveyItemCompositeEnableNeutral';
export const SET_SURVEY_ITEM_COMPOSITE_ENABLE_NEUTRAL_CHILDREN = 'setSurveyItemCompositeEnableNeutralChildren';
export const SET_SURVEY_ITEM_COMPOSITE_ENABLE_PROMOTER = 'setSurveyItemCompositeEnablePromoter';
export const SET_SURVEY_ITEM_COMPOSITE_ENABLE_PROMOTER_CHILDREN = 'setSurveyItemCompositeEnablePromoterChildren';
export const SET_CHANNEL = 'setChannel';
export const SET_WEIGHT = 'setWeight';
export const SET_REPORT = 'setReport';
export const CLEAR_REPORT = 'clearReport';
export const SET_SURVEY_UUID = 'setSurveyUuid';
export const SET_SURVEY_ITEM = 'setSurveyItem';
